'use client'

import type { ComponentProps } from 'react'
import { SearchInput } from '@repo/ui'

import { ChainFilterDropdown } from './ChainFilterDropdown'
import { useTokenSelectContext } from './TokenSelectProvider'

type TokenSelectSearchProps = {
  variant?: ComponentProps<typeof SearchInput>['variant']
  placeholder?: string
}

export function TokenSelectSearch({ variant, placeholder = 'Search' }: TokenSelectSearchProps) {
  const { search, setSearch, multiChain, chains, selectedChain, setSelectedChain } =
    useTokenSelectContext()

  return (
    <div className="relative -m-0.5 p-0.5">
      <SearchInput
        value={search}
        onChange={e => setSearch(e.target.value)}
        placeholder={placeholder}
        data-testid="token-select-search"
        variant={variant}
        className={multiChain ? 'pr-18' : undefined}
      />
      {multiChain && (
        <div className="absolute inset-y-0 right-0 flex items-center pr-3">
          <ChainFilterDropdown
            chains={chains}
            selectedChain={selectedChain}
            onChainSelect={setSelectedChain}
          />
        </div>
      )}
    </div>
  )
}
